import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { PrintQueueStatus } from '@liefersoft/pos-ui-core'
import { NavBarSettings, SettingItem, TseSettingItem } from './index.styled'
import phone from '../../../img/svg/header/phone.svg'
import socket from '../../../img/svg/header/socket.svg'
import { selectCompanyData } from '../../../redux/selector/system'
import { setAppModal } from '../../../redux/action/system'

const Indicators = React.memo(() => {
	const { i18n } = useTranslation()
	const toggled = useSelector(store => store.system.toggled)
	const socketIoClientConnected = useSelector(store => !!store.socket.socketIoClient?.connected)
	const printerDesktopSessionsExist = useSelector(store => !!store.socket.printerDesktopSessions?.length)
	const voipDesktopSessionsExist = useSelector(store => !!store.socket.voipDesktopSessions?.length)
	const connectedVoipListExist = useSelector(store => !!store.phoneStore.phones?.filter(item => item.status === 'CONNECTED')?.length)
	const tseIsActive = useSelector(store => store.tse.config?.status === 'ACTIVE')
	const invalidDataTseStatus = useSelector(store => store.tse.config?.status === 'NOT_ENOUGH_DATA')
	const companyCountryCode = useSelector(selectCompanyData('countryCode'))
	const companyData = useSelector(store => store.company.companyData)
	const dispatch = useDispatch()
	const isFranchise = companyData?.franchiseMetaData?.type === 'FRANCHISE'
	const isLocatedInAustria = companyCountryCode === 'AUT'
	const layoutPhone = (toggled ? 'toggled ' : '') + (voipDesktopSessionsExist && connectedVoipListExist ? 'green ' : '')
	const layoutSocketStatus = (toggled ? 'toggled ' : '') + (socketIoClientConnected ? 'green ' : '')
	const layoutTse = 'button ' + (toggled ? 'toggled ' : '') + (tseIsActive ? 'green ' : '')

	const openTseModal = useCallback(() => {
		if (tseIsActive) {
			dispatch(setAppModal({ tseInformationModalShow: true }))
		} else {
			if (invalidDataTseStatus && isLocatedInAustria) {
				dispatch(setAppModal({ tseInvalidDataModalShow: true }))
			} else {
				dispatch(setAppModal({ tseDisabledModalShow: true }))
			}
		}
	}, [tseIsActive, invalidDataTseStatus, isLocatedInAustria, dispatch])

	if (isFranchise) return null

	return (
		<NavBarSettings className={toggled ? 'toggled' : ''}>
			<PrintQueueStatus locale={i18n.language} queueEnabled printersOnline={printerDesktopSessionsExist} />
			<SettingItem id="phone-status" to="/settings/program/phone" className={layoutPhone} tabIndex="-1">
				<img src={phone} alt="phones" />
			</SettingItem>
			<SettingItem id="socket-status" to="/settings" className={layoutSocketStatus} tabIndex="-1">
				<img src={socket} alt="socket" />
			</SettingItem>
			<TseSettingItem className={layoutTse}
											onClick={openTseModal}
											tabIndex="-1">
				TSE
			</TseSettingItem>
		</NavBarSettings>
	)
})

Indicators.displayName = 'Indicators'
export default Indicators
